import * as tslib_1 from "tslib";
import { Prop, Component, Watch, Inject } from 'vue-property-decorator';
import { FormControlValueService, ReverseQueryService, } from '@cloudpivot/form/src/common/services';
import BaseControlAdapter from '@cloudpivot/form/src/renderer/components/pc/base-control-adapter.vue';
import filterCard from '@cloudpivot/list/src/components/pc/components/filter-card/filter-card.vue';
import { FormBuilderHelper } from '@cloudpivot/form/src/renderer/controls/form-builder-helper';
import ImportModals from '@cloudpivot/form/src/common/components/import-data/import.vue';
import UseRepeatModals from '@cloudpivot/form/src/common/components/import-data/usename-repeat/index.vue';
import sheetFilter from '@cloudpivot/form/src/common/components/import-data/sheet-filter/index.vue';
import common from '@cloudpivot/common/pc';
import { FormSheetControl } from '@cloudpivot/form/src/common/controls/form-sheet-control';
import { UploadControl } from '@cloudpivot/form/src/common/controls/upload-control';
import { RelevanceFormControl } from '@cloudpivot/form/src/common/controls/relevance-form-control';
import numberFilter from '@cloudpivot/form/utils/number-filter';
import { listApi } from '@cloudpivot/api';
import { Popover, Divider, Button, Checkbox, Tooltip, Icon, Modal, Pagination, } from '@h3/antd-vue';
import SheetComp from './sheet.vue';
import alledit from './alledit.vue';
let FormSheet = class FormSheet extends FormSheetControl {
    constructor() {
        super(...arguments);
        this.isFullScreen = false;
        // 分页配置项
        this.pageSizeOptions = ['10', '20', '50', '100', '200', '300'];
        this.pageSize = 20;
        this.pageIndex = 1;
        this.sheetImport = '22';
        this.importDataNum = null;
        this.showModal2 = false;
        this.showModalLength = 0;
        /**
         * 子表导入,导出代码
         */
        this.showModal = false;
        // sheetParams:any = {}
        // 是否显示人员重复的弹框
        this.showRepeatModal = false;
        this.isShowRelevance = false;
        this.selected = [];
        this.importData = {
            headColumns: this.dataItem,
            queryField: '',
            secondImportData: [],
        };
        this.importStatu = {
            status: 0,
            successNum: 0,
            failNum: 0,
            fileName: '',
        };
        this.isShowQueryItem = false; // 是否显示查询条件
        this.queryConditionSource = [];
        this.queryData = {};
    }
    get isInitNewRows() {
        const ctrl = this.getCtrl();
        if (!ctrl) {
            localStorage.setItem('isInitSheet', 'false');
            return false;
        }
        const isInitSheet = !(ctrl.value.length === this.rows.length);
        localStorage.setItem('isInitSheet', `${isInitSheet}`);
        return isInitSheet;
    }
    get canDelete() {
        return this.checkeds.some((c) => c);
    }
    get canEdits() {
        return this.checkeds.some((c) => c);
    }
    get total() {
        return this.rows.length;
    }
    get pageStart() {
        const start = (this.pageIndex - 1) * this.pageSize;
        return start;
    }
    get pageEnd() {
        let end = this.pageIndex * this.pageSize;
        if (end > this.total) {
            end = this.total;
        }
        return end;
    }
    get pagingRows() {
        return this.rows.slice(this.pageStart, this.pageEnd);
    }
    get pagingCheckeds() {
        return this.checkeds.slice(this.pageStart, this.pageEnd);
    }
    onIsEditChange() {
        // this.$set(this.control,'edit',!this.readonly);
        super.edit();
    }
    setControl() {
        const ctrl = this.getCtrl();
        if (!ctrl) {
            return;
        }
        sessionStorage.removeItem('sheet-' + this.id);
        this.reset();
        super.listenPropertyChange();
        this.initRows(this.canFull, 'pc');
        super.initStat();
        this.checkeds = this.rows.map(() => false);
        super.listenRowChange();
        if (this.canFull && this.control.edit) {
            super.edit();
        }
    }
    onCheck(checkeds) {
        this.checkeds.splice(this.pageStart, this.pageEnd - this.pageStart, ...checkeds);
    }
    onCheckAll(check) {
        this.checkeds = this.checkeds.map(() => check);
    }
    onColumnResize(data) {
        if (this.emitSheetColumnResize) {
            data.sheet = this.sheet;
            this.emitSheetColumnResize(data);
        }
    }
    onFreezeColumn(columnKey, freeze) {
        this.$emit('freezeColumn', columnKey, freeze);
    }
    onPageIndexChange(page, size) {
        this.pageIndex = page;
    }
    onPageSizeChange(page, size) {
        this.pageIndex = 1;
        this.pageSize = size;
    }
    // 批量编辑
    allEdit() {
        console.log(this.sheet);
        let indexs = [];
        for (let i = 0; i < this.checkeds.length; i++) {
            let s = this.checkeds[i];
            if (s) {
                indexs.push(i);
            }
        }
        this.showModalLength = indexs.length;
        this.showModal2 = true;
    }
    // 批量编辑确认
    onshowModal2() {
        this.$refs['allEdit'].emits();
    }
    // 批量编辑
    alledits(value) {
        console.log(value);
        this.showModal2 = false;
        this.showModalLength = 0;
        if (Object.values(value).length) {
            let indexs = [];
            for (let i = 0; i < this.checkeds.length; i++) {
                let s = this.checkeds[i];
                if (s) {
                    indexs.push(i);
                }
            }
            try {
                this.rows.forEach((d, i) => {
                    if (indexs.indexOf(i) > -1) {
                        Object.keys(value).forEach((k) => {
                            d.forEach((s) => {
                                if (value[k].key === s.key) {
                                    if ([1, 2, 4, 5, 6, 7].indexOf(s.type) > -1) {
                                        // 短文本,长文本,数值,单选,复选,下拉
                                        if (s.type === 4) {
                                            // 数值
                                            console.log('value[k].value==>', value[k].value);
                                            s.controller.value = value[k].value * 1;
                                        }
                                        else {
                                            s.controller.value = value[k].value;
                                        }
                                    }
                                    else if (s.type === 3) {
                                        // 日期
                                        s.controller.value = new Date(value[k].value);
                                    }
                                }
                            });
                        });
                    }
                });
                this.$message.success(`${this.$i18n.locale === 'zh'
                    ? '操作成功'
                    : 'Successful operation'}`);
            }
            catch (error) {
                this.$message.error(`${this.$i18n.locale === 'zh'
                    ? '操作失败'
                    : 'operation failed'}`);
            }
        }
    }
    removeChecked() {
        this.importDataNum = null;
        let indexs = [];
        let indexCopy = [];
        for (let i = 0; i < this.checkeds.length; i++) {
            let s = this.checkeds[i];
            let row = this.rows[i];
            if (s && i < this.rows.length) {
                indexs.push(row[0].controller.options.rowIndex);
                indexCopy.push(i);
            }
        }
        this.removeRows(indexs);
        // 子表筛选过后处理逻辑
        if (indexs.join() !== indexCopy.join()) {
            indexCopy
                .sort((a, b) => a - b)
                .reverse()
                .forEach((d) => {
                this.rows.splice(d, 1);
            });
            this.onCheckAll(false);
        }
        if (this.pagingRows.length === 0) {
            this.pageIndex = 1;
        }
    }
    copy(idx, row) {
        this.importDataNum = null;
        super.copy(idx, row);
    }
    add(idx, vals) {
        this.importDataNum = null;
        const row = typeof idx === 'number' ? this.addRow(vals, idx) : this.addRow(vals);
    }
    splice(idx) {
        this.removeRow(idx);
    }
    rowInserted(index, row) {
        this.importDataNum = null;
        this.checkeds.splice(index, 0, false);
        if (this.control.edit) {
            super.edit();
        }
        this.syncScroll();
    }
    rowRemoved(index, row) {
        this.importDataNum = null;
        this.checkeds.splice(index, 1);
    }
    rowsInserted(index, rows) {
        this.importDataNum = null;
        const news = rows.map(() => false);
        this.checkeds.splice(index, 0, ...news);
        if (this.control.edit) {
            super.edit();
        }
        this.syncScroll();
    }
    rowsRemoved(indexs) {
        this.importDataNum = null;
        for (const index of indexs) {
            this.checkeds.splice(index, 1);
        }
    }
    syncScroll() {
        this.$nextTick(() => {
            const $sheet = this.$refs.sheet;
            if ($sheet) {
                $sheet.syncScrollLeft();
                $sheet.handleRootScroll();
            }
        });
    }
    importSheet() {
        this.importDataNum = null;
        this.showModal = true;
    }
    /**
     * reset
     */
    handleCancel() {
        this.importDataNum = null;
        let fileName = this.$refs.importModals.errorFile ||
            this.$refs.importModals.importFileName;
        if (fileName) {
            //清除临时文件
            listApi.deleteTemporaryFile({ fileName });
        }
        this.showModal = false;
    }
    /**
     * 导出
     */
    exportSheet() {
        // debugger
        this.importDataNum = null;
        const exportRows = [];
        // const ctrl:any = JSON.parse(JSON.stringify(this.ctrl));
        this.checkeds.forEach((r, index) => {
            // debugger
            let row = this.rows[index];
            if (r && index < this.rows.length) {
                let i = row[0].controller.options.rowIndex;
                const value = this.ctrl.rows[i].value;
                if (value.id) {
                    exportRows.push(value.id);
                }
            }
        });
        const params = Object.assign({}, this.sheetParams);
        // 获取导出权限数据
        const schemaCode = this.sheetParams.subSchemaCode;
        const permissData = this.formPermission.dataPermissions[schemaCode];
        params.permiss = permissData;
        params.name =
            this.control.options.name +
                this.$t('cloudpivot.form.renderer.exportFile').toString();
        if (exportRows.length > 0) {
            params.objectIds = exportRows;
        }
        UploadControl.service.exportSheet(params);
    }
    // onListChange(val) {
    //   debugger;
    // };
    beforeCreate() {
        const comp = RelevanceFormControl.loadListSelector();
        this.$options.components.ListSelector = comp;
    }
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const formControls = this.getFormControls();
            const dataitems = yield RelevanceFormControl.service.dataitemsOf(this.schemaCode);
            this.selected.forEach((res) => {
                const obj = {};
                this.control.columns.forEach((c) => {
                    if (c.key === this.controlOpts.importFormRelevanceForm) {
                        let formData = res;
                        if (this.mappings) {
                            formData = ReverseQueryService.convertForMappings(res, dataitems, this.mappings, formControls);
                        }
                        obj[c.key] = formData;
                    }
                    else {
                        // obj[c.key] = null;
                    }
                });
                const backRow = this.addRow();
                backRow.value = obj;
            });
            this.selected = [];
            this.onModalCancel();
        });
    }
    customBtnclick(code) {
        super.customBtnclick(code);
    }
    onModalCancel() {
        this.isShowRelevance = false;
    }
    importRelevance() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isShowRelevance = true;
            this.query = this.getParams(false);
            this.columns = this.relavanceColumns();
            this.formTitleObj = yield RelevanceFormControl.service.getBizmodelTitle(this.schemaCode || '');
        });
    }
    importFinishe(val) {
        this.importDataNum = val.length + this.rows.length;
        if (!val)
            return;
        for (const col of this.control.columns) {
            val.forEach((row) => {
                if (row[col.key] !== undefined && row[col.key] !== null) {
                    if (col.options.computeFormula) {
                        delete row[col.key];
                    }
                    row[col.key] = FormControlValueService.convert(col.type, row[col.key], col.options && col.options.multi);
                }
                else {
                    row[col.key] = FormBuilderHelper.getControlValue(col);
                }
            });
        }
        for (const row of val) {
            this.addRow(row);
        }
        // this.getCtrl().value =val
    }
    closeRepeatModal() {
        this.showRepeatModal = false;
    }
    editFinishe(val) {
        this.closeRepeatModal();
        this.importFinishe(val);
    }
    /**
     * @description: 列表导入时候，人员名称重复，弹出修复数据弹框
     * @param data.errorType 错误类型 data.successCount 成功数量  data.errorCount失败数量  data.fileName 错误模板名称
     * @return:
     */
    repeatErrorHandle(data) {
        this.importStatu.status = data.errorType;
        this.importStatu.successNum = data.successCount;
        this.importStatu.failNum = data.errorCount;
        this.importStatu.fileName = data.fileName;
        this.importData.secondImportData = data.secondImportData || [];
        if (data.data) {
            this.importFinishe(data.data);
        }
        this.showModal = false;
        this.showRepeatModal = true;
    }
    get sheetParams() {
        const formStatus = {
            DRAFT: 0,
            PROCESSING: 1,
            CANCELLED: 2,
            COMPLETED: 3,
        };
        const params = Object.assign({}, this.control.options.sheetParams);
        params.sequenceStatus = formStatus[params.sequenceStatus];
        return params;
    }
    toggleQuery() {
        this.isShowQueryItem = !this.isShowQueryItem;
    }
    // 点击搜索
    onSearch(params, nameObj, queryData) {
        console.log(params, nameObj, queryData);
        this.isShowQueryItem = false;
        const Ctrl = this.getCtrl();
        const sheet = Ctrl;
        const formControls = this.getFormControls();
        const sheets = formControls.find((c) => c.key === this.id);
        if (sheet && sheet.rows.length > 0) {
            // 清空子表数据在获取
            this.rows = [];
            // 标记筛选子表
            sessionStorage.setItem('sheet-' + this.id, '1');
            if (Object.keys(params).length) {
                const vals = this.dataTranslateToFilterCard(params, nameObj);
                this.queryConditionSource = vals;
                // 获取过滤的数据
                sheet.rows.forEach((g, i) => {
                    if (!this.hasRows(g, params)) {
                        this.buildRow(i, g);
                    }
                });
                // this.initFilterStat(sheets);
            }
            else {
                this.queryConditionSource = [];
                sheet.rows.forEach((g, i) => {
                    this.buildRow(i, g);
                });
                // this.initStat();
            }
        }
        this.onCheckAll(false);
        this.pageIndex = 1;
    }
    // 筛选过滤条件
    hasRows(objs, params) {
        let status = 0;
        let obj = {};
        for (let key in objs.value) {
            obj[key] = objs.value[key];
        }
        for (let i in params) {
            const arr = Array.isArray(obj[i]) ? obj[i].map((d) => d.id) : [];
            // 支持类型：短文本、日期、数值、选人控件、逻辑、关联表单
            // const type = [1, 3, 4, 50, 51, 8, 80, 81];
            switch (params[i].type) {
                case 1:
                case 4:
                    (obj[i] + '').toLowerCase().indexOf((params[i].value + '').toLowerCase()) > -1 ? 0 : status++;
                    break;
                case 3:
                    // 日期
                    new Date(params[i].value).getTime() === new Date(obj[i]).getTime()
                        ? 0
                        : status++;
                    break;
                case 8:
                    // 逻辑
                    JSON.parse(params[i].value) === obj[i] ? 0 : status++;
                    break;
                case 50:
                case 51:
                case 81:
                    // 选人和关联多选
                    const arr1 = params[i].value.map((d) => d.id);
                    arr.some((r) => arr1.indexOf(r) >= 0) ? 0 : status++;
                    break;
                case 80:
                    // 关联单选
                    params[i].value.hasOwnProperty('id') && params[i].value.id === obj[i].id
                        ? 0
                        : status++;
                    break;
            }
        }
        return status;
    }
    /**
     * 将查询条件转成组件需要的格式
     * @params data 需要转的数据
     */
    dataTranslateToFilterCard(data, nameObj) {
        const deepData = JSON.parse(JSON.stringify(data));
        const vals = [];
        let type = [50, 51, 81];
        Object.keys(deepData).forEach((key) => {
            // debugger
            let content = deepData[key].type === 80
                ? deepData[key].value.name
                : type.indexOf(deepData[key].type) > -1
                    ? deepData[key].value.map((res) => res.name).join(',')
                    : deepData[key].value;
            vals.push({
                name: nameObj[key].name,
                name_i18n: nameObj[key].name_i18n,
                content: content,
                type: -1,
            });
        });
        return vals;
    }
    // 重置
    onReset() {
        this.queryConditionSource = [];
        this.queryData = {};
        this.importDataNum = null;
        this.onSearch({}, {}, {});
    }
    // 点击过滤弹出层外隐藏
    hideQueryItem() {
        if (!this.isShowQueryItem)
            return;
        this.isShowQueryItem = false;
    }
};
tslib_1.__decorate([
    Prop({
        default: false,
    })
], FormSheet.prototype, "canFull", void 0);
tslib_1.__decorate([
    Prop()
], FormSheet.prototype, "formPermission", void 0);
tslib_1.__decorate([
    Inject()
], FormSheet.prototype, "emitSheetColumnResize", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], FormSheet.prototype, "frozenKeys", void 0);
tslib_1.__decorate([
    Watch('isEdit')
], FormSheet.prototype, "onIsEditChange", null);
FormSheet = tslib_1.__decorate([
    Component({
        name: 'form-sheet',
        components: {
            AllEdit: alledit,
            sheetFilter: sheetFilter,
            filterCard: filterCard,
            AModal: Modal,
            AIcon: Icon,
            APopover: Popover,
            ADivider: Divider,
            AButton: Button,
            ACheckbox: Checkbox,
            ATooltip: Tooltip,
            APagination: Pagination,
            BaseControlAdapter,
            ImportModals,
            UseRepeatModals,
            H3Panel: common.components.Panel,
            H3SizeSlider: common.components.H3SizeSlider,
            Sheet: SheetComp,
        },
        filters: {
            number: numberFilter,
        },
    })
], FormSheet);
export default FormSheet;
